import React from 'react'

import './content-loader.scss'

import useDebounce from '../../../../commons/src/hooks/use-debounce'
import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

import LoadingIndicator from '../../../../commons/src/components/loading-indicator'
import Paragraph from '../../../../commons/src/components/paragraph'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    delay?: number
    loading?: boolean
    description?: React.ReactNode
  }
>

const ContentLoader = ({className, delay = 500, loading = false, description, ...props}: Props) => {
  const debouncedLoading = useDebounce(loading, delay, false)

  return (
    <div
      {...props}
      className={cn('ContentLoader', {loading: debouncedLoading && loading}, className)}
    >
      <LoadingIndicator />
      {description && <Paragraph minor>{description}</Paragraph>}
    </div>
  )
}

export default ContentLoader
